import { Button } from '@readcloud/component-library';
import { useBoolean } from 'ahooks';
import { FC, useState } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import 'regenerator-runtime/runtime';
import { Student } from '../../../../api';
import { BulkImportModal } from './components/BulkImportModal';
import { BulkImportProps } from './types';

export const BulkImport: FC<BulkImportProps> = ({ onSubmit, disabled }) => {
  const [loading, { toggle }] = useBoolean(false);
  const [error, setError] = useState<Error>(null);
  const [isModalOpen, { toggle: toggleModal, setTrue, setFalse }] =
    useBoolean(false);

  const onOpen = () => {
    setError(null);
    setTrue();
  };

  const onModalSubmit = async (values: Student[]) => {
    try {
      toggle();
      await onSubmit(values);
      setFalse();
    } catch (err) {
      setError(err);
    } finally {
      toggle();
    }
  };

  return (
    <>
      <Button
        id="bulkImport"
        className="mr-2"
        size="sm"
        title="Bulk Import"
        onClick={onOpen}
        disabled={disabled}
      >
        <i className="fe fe-database" />
      </Button>
      <UncontrolledTooltip placement="bottom" target="bulkImport">
        Add CSV
      </UncontrolledTooltip>
      <BulkImportModal
        isOpen={isModalOpen}
        onToggle={toggleModal}
        onSubmit={onModalSubmit}
        loading={loading}
        error={error}
      />
    </>
  );
};
